import type { TradePathData } from "../api/trade";
import { Any } from "../fakeTypes";

export type WidgetEventMessage<T = Any> = {
  type: string;
  payload: T;
};

export enum WidgetWindowEvents {
  UPDATE_EXCHANGE = "update-exchange",
  UPDATE_PAIR = "update-pair",
  CONNECT_SPECIFIC_EXCHANGE = "connect-specific-exchange",
  CONNECT_EXCHANGE = "connect-exchange",
  BACK_TO_CAMPAIGNS = "back-to-campaigns",
}

export const isWidgetEventMessage = (message: Any): message is WidgetEventMessage => {
  return message && typeof message === "object" && "type" in message && "payload" in message;
};

export type WidgetEventUpdatePairPayload = {
  pairSymbol: string;
  precision: number;
  isTradeSquare: boolean;
  /** Trade path for multi-route trades (e.g., AAA -> BTC -> USDT) */
  tradePath?: TradePathData[];
} | null;

export type WidgetEventUpdateExchangePayload = {
  exchangeId: string;
  accountId: string;
} | null;

export type WidgetEventConnectSpecificExchangePayload = {
  exchangeId: string;
} | null;

export type WidgetEventSelectAccountPayload = {
  accountId: string;
} | null;
